import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/page/Solutions/CallEnglish"),
    meta: {
      title: "callenglish",
    },
  },
  {
    path: "/callenglish",
    component: () => import("@/page/Solutions/CallEnglish"),
    meta: {
      title: "callenglish",
    },
  },
  {
    path: "/edu-tech",
    component: () => import("@/page/Solutions/EduTech"),
    meta: {
      title: "edu-tech",
    },
  },
  {
    path: "/imooc",
    component: () => import("@/page/Solutions/IMooc"),
    meta: {
      title: "imooc",
    },
  },
  {
    path: "/aitutor",
    component: () => import("@/page/Solutions/AITutor"),
    meta: {
      title: "aitutor",
    },
  },
  {
    path: "/custom-cont",
    component: () => import("@/page/Solutions/CustomCont"),
    meta: {
      title: "custom-cont",
    },
  },
  // ctm tutor app 다운로드
  {
    path: "/ctm_tutor_app/down",
    component: () => import("@/page/CtmTutorApp/down.vue"),
    meta: {
      title: "강사 앱 다운로드",
    },
  },
];

const carrotenglish = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
});

carrotenglish.afterEach((to) => {
  const title = to.meta.title === undefined ? "CarrotSolutions" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default carrotenglish;
